const Muze = require('./muze');

module.exports = Muze.default ? Muze.default : Muze;
